"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _buttonTexts = require("./texts/buttonTexts");
Object.keys(_buttonTexts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _buttonTexts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _buttonTexts[key];
    }
  });
});
var _dialogTexts = require("./texts/dialogTexts");
Object.keys(_dialogTexts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dialogTexts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dialogTexts[key];
    }
  });
});
var _messageTexts = require("./texts/messageTexts");
Object.keys(_messageTexts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _messageTexts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _messageTexts[key];
    }
  });
});
var _profileTexts = require("./texts/profileTexts");
Object.keys(_profileTexts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _profileTexts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _profileTexts[key];
    }
  });
});
var _qrCodeTexts = require("./texts/qrCodeTexts");
Object.keys(_qrCodeTexts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _qrCodeTexts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _qrCodeTexts[key];
    }
  });
});